import { Image } from 'antd-mobile';
import Image1 from '../../assets/image/display/1.jpeg';

import Image3 from '../../assets/image/display/3.jpeg';
import Image4 from '../../assets/image/display/4.jpeg';
import Image5 from '../../assets/image/display/5.jpeg';
import Image6 from '../../assets/image/display/6.jpeg';
import Image7 from '../../assets/image/display/7.jpeg';
import Image8 from '../../assets/image/display/8.jpeg';

const Demo = () => {
  return (
    <div>
      <Image src={Image1} />

      <Image src={Image3} />
      <Image src={Image4} />
      <Image src={Image5} />
      <Image src={Image6} />
      <Image src={Image7} />
      <Image src={Image8} />
    </div>
  );
};
export default Demo;
